import axios from 'axios';
import { LockModel, LockMaintenanceModel, LockSearchModel } from '@/types';
import AxiosConfiguration from '@/classes/AxiosConfiguration';
import { FetchUtils } from '@/utils/fetchUtils';

const LockApiUrl = 'lock/';

export const LockService = {
  async extendLockAsync(id: number): Promise<LockModel> {
    const response = await AxiosConfiguration.axiosWithoutNotification.put(LockApiUrl + id);
    return response.data;
  },
  async releaseLockAsync(id: number, keepAlive = false) {
    const url = `${LockApiUrl}${id}`;
    // when exiting the site calls to release lock may not be executed unless set to keep alive
    if (keepAlive) {
      FetchUtils.deleteWithKeepAlive(url);
    } else {
      await axios.delete(url);
    }
  },
  async releaseAnyUsersLockAsync(id: number) {
      await axios.delete(`${LockApiUrl}anyuser/${id.toString()}`);
  },
  async getLocksAsync(lockSearchModel: LockSearchModel): Promise<LockMaintenanceModel> {
      const locks = await AxiosConfiguration.axiosWithErrorPage.get(LockApiUrl, {
          params: {
              applicationType: lockSearchModel.applicationType,
              lockTypeId: lockSearchModel.lockTypeId,
              showPersistentLocks: lockSearchModel.showPersistentLocks
          }
      });
      return locks.data;
  }
};
